<span *ngIf="selectedTags?.length === 0 && phxPlaceholder" class="phx-placeholder">{{ phxPlaceholder }}</span>
<ng-container *ngIf="selectedTags?.length > 0">
  <phx-tag
    *ngFor="let tag of selectedTags; index as i"
    [phxSuffixIcon]="tag.suffixIcon || phxTagDefaultValues.suffixIcon"
    [phxTagType]="tag.tagType || phxTagDefaultValues.tagType"
    [phxContrast]="tag.contrast || phxTagDefaultValues.contrast"
    [disabled]="disabled || tag.disabled || phxTagDefaultValues.disabled"
    [phxSize]="tag.size || phxTagDefaultValues.size"
    (phxOnClick)="removeTag(i)">
    {{ tag.label }}
  </phx-tag>
</ng-container>